import { useMutation } from "@tanstack/react-query";

import { downloadTimesheet } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";
import type { TimesheetFormat } from "../types";
import { saveBlob, timesheetFallbackFilename } from "../utils/download";

export function useDownloadTimesheet(month: string) {
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useMutation({
		mutationFn: async (format: TimesheetFormat): Promise<string> => {
			if (!activeCanteiroId) throw new Error("missing worksite");
			const { blob, filename } = await downloadTimesheet(
				activeCanteiroId,
				month,
				format,
				timesheetFallbackFilename(month, format),
			);
			saveBlob(blob, filename);
			return filename;
		},
	});
}
